function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { guid } from '@bydesign-ui/utils';
import { Emitter } from '@bydesign-ui/hooks';
export var CascaderState;

(function (CascaderState) {
  CascaderState[CascaderState["UNSELECTED"] = 0] = "UNSELECTED";
  CascaderState[CascaderState["PARTIAL"] = 1] = "PARTIAL";
  CascaderState[CascaderState["SELECTED"] = 2] = "SELECTED";
})(CascaderState || (CascaderState = {}));

export var CascaderCore = function (_Emitter) {
  _inherits(CascaderCore, _Emitter);

  var _super = _createSuper(CascaderCore);

  function CascaderCore() {
    var _this;

    _classCallCheck(this, CascaderCore);

    _this = _super.apply(this, arguments);
    _this.multiple = false;
    _this.value = [];
    _this.spread = false;
    _this.disabled = false;
    _this.readonly = false;
    _this.showAll = false;
    _this.hashMap = {};
    _this.valueHash = {};
    _this.valueMap = {};
    _this.root = '';
    _this.datasource = [];
    _this.queries = [];
    _this.columnTitles = [];
    _this.accordion = true;
    _this.draggable = false;
    _this.partialCheckAble = true;
    _this.selectToExpand = true;
    _this.clickToExpand = false;
    _this.checkedStrategy = 'parent';

    _this.load = function () {
      return Promise.resolve([]);
    };

    return _this;
  }

  _createClass(CascaderCore, [{
    key: "setDefaultSelecteds",
    value: function setDefaultSelecteds(defaultIds) {
      var _this2 = this;

      defaultIds.forEach(function (item) {
        var id = _this2.getIdByValue(item);

        if (!_this2.hashMap[id]) {
          return;
        }

        _this2.updateSelectedState(id, CascaderState.SELECTED, true);
      });
    }
  }, {
    key: "getDraggable",
    value: function getDraggable() {
      return this.draggable;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.datasource = [];
      this.hashMap = {};
      this.valueHash = {};
      this.valueMap = {};
      this.queries = [];
      this.removeAllListeners('change');
      this.removeAllListeners('value-change');
    }
  }, {
    key: "getRootId",
    value: function getRootId() {
      return this.root;
    }
  }, {
    key: "getItemInfo",
    value: function getItemInfo(id) {
      return this.hashMap[id];
    }
  }, {
    key: "setItemState",
    value: function setItemState(id, newState) {
      var _a, _b, _c;

      if (this.hashMap[id].disabled || this.hashMap[id].readonly || !this.hashMap[id].selectable) {
        return;
      }

      if (this.multiple) {
        var _this$hashMap$id = this.hashMap[id],
            state = _this$hashMap$id.state,
            children = _this$hashMap$id.children,
            isLeaf = _this$hashMap$id.isLeaf;
        newState = newState == null ? state === CascaderState.SELECTED ? CascaderState.UNSELECTED : CascaderState.SELECTED : newState;

        if (this.partialCheckAble && !isLeaf && children.every(function (child) {
          return child.disabled;
        })) {
          return;
        }

        this.updateSelectedState(id, newState);
      } else {
        this.resetHashState();
        this.updateSelectedState(id, CascaderState.SELECTED);
      }

      this.emit('value-change');
      this.emit('change', this.value = this.getValueFromSelected(), this.multiple ? (((_a = this.hashMap[id]) === null || _a === void 0 ? void 0 : _a.children) || []).map(function (child) {
        var _a;

        return (_a = child === null || child === void 0 ? void 0 : child.ref) === null || _a === void 0 ? void 0 : _a.current;
      }) : (_c = (_b = this.hashMap[id]) === null || _b === void 0 ? void 0 : _b.ref) === null || _c === void 0 ? void 0 : _c.current);
    }
  }, {
    key: "resetState",
    value: function resetState() {
      this.resetHashState();
      this.emit('value-change');
      this.emit('change', this.value = this.getValueFromSelected());
    }
  }, {
    key: "setQuery",
    value: function setQuery(query) {
      var _this3 = this;

      this.queries = Object.keys(this.hashMap).filter(function (key) {
        return _this3.hashMap[key].search.indexOf(query) >= 0;
      });
      this.emit('query-change', this.queries);
    }
  }, {
    key: "getQueries",
    value: function getQueries() {
      return this.queries;
    }
  }, {
    key: "getDisplayInfo",
    value: function getDisplayInfo() {
      var _this4 = this;

      return this.getIdFromSelected().map(function (item) {
        return _this4.hashMap[item];
      });
    }
  }, {
    key: "getGroupDisplayInfo",
    value: function getGroupDisplayInfo() {
      var _this5 = this;

      var result = this.getIdFromSelected().map(function (item) {
        return _this5.hashMap[item];
      });
      var map = [];
      result.forEach(function (item) {
        map[item.nodePath.length - 1] = map[item.nodePath.length - 1] || [];
        map[item.nodePath.length - 1].push(item);
      });
      var ret = [];

      for (var i = 0; i < map.length; i++) {
        if (map[i]) {
          ret.push({
            level: i - 1,
            list: map[i]
          });
        }
      }

      return ret;
    }
  }, {
    key: "getDescendants",
    value: function getDescendants(ancestorId) {
      var _this6 = this;

      var ancestor = this.getItemInfo(ancestorId);
      var descendants = [];
      ancestor.children.forEach(function (child) {
        descendants.push(child.id);
        descendants = descendants.concat(_this6.getDescendants(child.id));
      });
      return descendants;
    }
  }, {
    key: "isAncestor",
    value: function isAncestor(ancestorId, descendantId) {
      var descendant = this.getItemInfo(descendantId);
      return descendant.nodePath.indexOf(ancestorId) > -1;
    }
  }, {
    key: "setQueryState",
    value: function setQueryState(ids, newState) {
      var _this7 = this;

      var queries = this.queries.map(function (item) {
        return _this7.getItemInfo(item);
      });
      var checked = queries.every(function (item) {
        return item.state === CascaderState.SELECTED;
      });
      var state = newState == null ? checked ? CascaderState.UNSELECTED : CascaderState.SELECTED : newState;
      queries = queries.filter(function (item) {
        return !item.disabled && item.state !== state;
      });

      if (!queries.length) {
        return [queries, state];
      }

      queries.forEach(function (item) {
        return _this7.updateSelectedState(item.id, state);
      });
      this.emit('value-change');
      this.emit('change', this.value = this.getValueFromSelected());
      return [queries, state];
    }
  }, {
    key: "updateCascaderOptions",
    value: function updateCascaderOptions(options) {
      var _this$needUpdate = this.needUpdate(options),
          _this$needUpdate2 = _slicedToArray(_this$needUpdate, 2),
          needUpdateDatasource = _this$needUpdate2[0],
          needUpdateValue = _this$needUpdate2[1];

      var prevValueHash = this.valueHash;

      if (needUpdateDatasource) {
        this.hashMap = {};
        this.valueHash = {};
        this.valueMap = {};
        this.queries = [];
        var root = this.createDataHashMap({
          label: '',
          value: '',
          children: this.datasource
        });
        this.setPos();
        this.emit('reset');
        this.root = root.id;
      }

      if (needUpdateValue) {
        this.setValueToSelected(options.value, needUpdateDatasource);
        this.emit('value-change');
      }

      if (needUpdateDatasource || needUpdateValue) {
        this.setDefaultSelecteds(options.value);
      }

      return {
        needUpdateDatasource: needUpdateDatasource,
        needUpdateValue: needUpdateValue,
        prevValueHash: prevValueHash
      };
    }
  }, {
    key: "setHashState",
    value: function setHashState(id, state) {
      var _this8 = this;

      var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var ignoreDisabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (deep && state === CascaderState.PARTIAL) {
        throw new Error('cant setStateAll partial');
      }

      var node = this.hashMap[id];

      if (!node) {
        throw new Error('cant setState for an inexistence item');
      }

      if (node.state === state || node.disabled && !ignoreDisabled) {
        return;
      }

      node.state = state;

      if (!deep || !node.children || !node.children.length) {
        return;
      }

      node.children.forEach(function (item) {
        return _this8.setHashState(item.id, state, deep);
      });
    }
  }, {
    key: "needUpdate",
    value: function needUpdate(options) {
      var _options$columnTitles = options.columnTitles,
          columnTitles = _options$columnTitles === void 0 ? [] : _options$columnTitles,
          _options$value = options.value,
          value = _options$value === void 0 ? [] : _options$value,
          nodeKey = options.nodeKey,
          _options$datasource = options.datasource,
          datasource = _options$datasource === void 0 ? [] : _options$datasource,
          _options$disabled = options.disabled,
          disabled = _options$disabled === void 0 ? false : _options$disabled,
          _options$readonly = options.readonly,
          readonly = _options$readonly === void 0 ? false : _options$readonly,
          _options$multiple = options.multiple,
          multiple = _options$multiple === void 0 ? false : _options$multiple,
          _options$spread = options.spread,
          spread = _options$spread === void 0 ? false : _options$spread,
          _options$showAll = options.showAll,
          showAll = _options$showAll === void 0 ? false : _options$showAll,
          _options$accordion = options.accordion,
          accordion = _options$accordion === void 0 ? true : _options$accordion,
          _options$draggable = options.draggable,
          draggable = _options$draggable === void 0 ? false : _options$draggable,
          _options$partialCheck = options.partialCheckAble,
          partialCheckAble = _options$partialCheck === void 0 ? true : _options$partialCheck,
          _options$clickToExpan = options.clickToExpand,
          clickToExpand = _options$clickToExpan === void 0 ? false : _options$clickToExpan,
          _options$selectToExpa = options.selectToExpand,
          selectToExpand = _options$selectToExpa === void 0 ? true : _options$selectToExpa,
          _options$checkedStrat = options.checkedStrategy,
          checkedStrategy = _options$checkedStrat === void 0 ? 'parent' : _options$checkedStrat,
          checkLeaf = options.checkLeaf,
          _options$load = options.load,
          load = _options$load === void 0 ? function () {
        return Promise.resolve([]);
      } : _options$load;
      var needUpdateDatasource = !this.root || this.datasource !== datasource || this.disabled !== disabled || this.readonly !== readonly || this.multiple !== multiple || this.showAll !== showAll;
      var needUpdateValue = needUpdateDatasource || this.value !== value || this.spread !== spread || this.checkedStrategy !== checkedStrategy;
      this.value = value;
      this.nodeKey = nodeKey;
      this.showAll = showAll;
      this.datasource = datasource;
      this.disabled = disabled;
      this.readonly = readonly;
      this.spread = spread;
      this.multiple = multiple;
      this.load = load;
      this.columnTitles = columnTitles;
      this.accordion = accordion;
      this.draggable = draggable;
      this.partialCheckAble = partialCheckAble;
      this.clickToExpand = clickToExpand;
      this.selectToExpand = selectToExpand;
      this.checkedStrategy = checkedStrategy;
      this.checkLeaf = checkLeaf;
      return [needUpdateDatasource, needUpdateValue];
    }
  }, {
    key: "createDataHashMap",
    value: function createDataHashMap(data) {
      var _this9 = this;

      var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var value = data.value,
          label = data.label,
          disabled = data.disabled,
          readonly = data.readonly,
          showAll = data.showAll,
          selectable = data.selectable,
          needLoad = data.needLoad,
          children = data.children,
          extra = data.extra,
          _data$type = data.type,
          type = _data$type === void 0 ? 'option' : _data$type,
          others = _objectWithoutProperties(data, ["value", "label", "disabled", "readonly", "showAll", "selectable", "needLoad", "children", "extra", "type"]);

      var isLeaf = this.checkLeaf !== undefined ? this.checkLeaf(data) : (!children || !children.length) && !needLoad;
      var id = parentId === null ? guid() : this.nodeKey !== undefined && data[this.nodeKey] !== undefined ? data[this.nodeKey] : guid();
      var realValue;

      if (value == null) {
        if (type === 'option') {
          console.error(new Error(label + 'is a value type without value'));
        } else if (!isLeaf && !this.spread && selectable) {
          console.error(new Error(label + 'has children without value'));
        }

        realValue = '';
      } else {
        realValue = value;
      }

      var map = this.hashMap[id] = _objectSpread(_objectSpread({}, others), {}, {
        id: id,
        parentId: parentId,
        value: realValue,
        values: [realValue],
        label: label,
        level: level,
        isLeaf: isLeaf,
        type: type,
        disabled: false,
        readonly: false,
        showAll: false,
        selectable: false,
        needLoad: false,
        loading: false,
        state: CascaderState.UNSELECTED,
        extra: extra,
        search: '',
        nodePath: [id],
        children: []
      });

      if (!parentId) {
        map.disabled = this.disabled;
        map.readonly = this.readonly;
        map.showAll = this.multiple && this.showAll;
        map.values = [];
      } else {
        var parent = this.hashMap[parentId];
        map.disabled = disabled != null ? disabled : this.partialCheckAble && parent.disabled;
        map.readonly = readonly || parent.readonly;
        map.selectable = isLeaf ? true : selectable != null ? selectable : this.multiple || !this.multiple && !this.partialCheckAble;
        map.needLoad = needLoad || false;
        map.search = parent.search ? parent.search + '/' + label : label;
        map.nodePath = parent.nodePath.concat(map.nodePath);
        map.showAll = showAll == null ? parent.showAll : this.multiple && showAll;
        map.values = parent.values.concat(map.values);
        var valueMap = this.valueMap;
        var index = 0;

        while (index < parent.values.length) {
          valueMap = valueMap[String(parent.values[index++])].map;
        }

        valueMap[String(value)] = {
          id: id,
          map: {}
        };
        this.valueHash[String(value)] = id;
      }

      if (children && children.length) {
        level++;
        map.children = children.map(function (child) {
          return _this9.createDataHashMap(child, id, level);
        });

        if (!map.readonly && !isLeaf) {
          map.readonly = map.children.every(function (child) {
            return child.readonly;
          });
        }
      }

      return map;
    }
  }, {
    key: "resetHashState",
    value: function resetHashState() {
      Object.values(this.hashMap).forEach(function (item) {
        return item.state = CascaderState.UNSELECTED;
      });
    }
  }, {
    key: "updateSelectedState",
    value: function updateSelectedState(id, state) {
      var _this10 = this;

      var ignoreDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (state === CascaderState.PARTIAL) {
        throw new Error('`state` could not be CHECKBOX_STATE_PARTIAL');
      }

      var pathNodes = this.hashMap[id].nodePath.map(function (item) {
        return _this10.hashMap[item];
      });

      if (!pathNodes.length) {
        return;
      }

      var current = pathNodes.pop() || null;

      if (!current || state === current.state) {
        return;
      }

      this.setHashState(current.id, state, !current.isLeaf && this.partialCheckAble && this.multiple, ignoreDisabled);

      if (!this.partialCheckAble || !this.multiple) {
        return;
      }

      var _loop2 = function _loop2() {
        current = pathNodes.pop() || null;

        if (!current) {
          return {
            v: void 0
          };
        }

        var children = current.children || [];
        var length = children.length;
        var selected = 0;
        var unselected = 0;
        children.forEach(function (child) {
          var childState = child.state;

          if (childState === CascaderState.SELECTED) {
            selected++;
          } else if (childState === CascaderState.UNSELECTED) {
            unselected++;
          }
        });

        if (unselected === length) {
          _this10.setHashState(current.id, CascaderState.UNSELECTED, false, ignoreDisabled);
        } else if (selected === length) {
          _this10.setHashState(current.id, CascaderState.SELECTED, false, ignoreDisabled);
        } else {
          _this10.setHashState(current.id, CascaderState.PARTIAL, false, ignoreDisabled);
        }
      };

      while (pathNodes.length) {
        var _ret = _loop2();

        if (_typeof(_ret) === "object") return _ret.v;
      }
    }
  }, {
    key: "getIdFromSelected",
    value: function getIdFromSelected() {
      var _this11 = this;

      var multiple = this.multiple,
          spread = this.spread,
          checkedStrategy = this.checkedStrategy;
      var result = Object.keys(this.hashMap).filter(function (key) {
        var _this11$hashMap$key = _this11.hashMap[key],
            state = _this11$hashMap$key.state,
            nodePath = _this11$hashMap$key.nodePath,
            isLeaf = _this11$hashMap$key.isLeaf,
            selectable = _this11$hashMap$key.selectable;

        if (state !== CascaderState.SELECTED) {
          return;
        }

        if (!_this11.partialCheckAble) {
          return true;
        }

        if (spread) {
          return isLeaf && selectable;
        }

        switch (checkedStrategy) {
          case 'all':
            return selectable;

          case 'child':
            return isLeaf && selectable;

          case 'parent':
          default:
            for (var i = 1; i < nodePath.length - 1; i++) {
              if (_this11.hashMap[nodePath[i]].state === CascaderState.SELECTED && _this11.hashMap[nodePath[i]].selectable) {
                return false;
              }
            }

            break;
        }

        return nodePath.length > 1;
      });

      if (!multiple && result.length > 1) {
        console.error('cascader has multiple value, but is not multiple');
      }

      return result;
    }
  }, {
    key: "getValueFromSelected",
    value: function getValueFromSelected() {
      var _this12 = this;

      var result = this.getIdFromSelected();
      return result.map(function (item) {
        return _this12.hashMap[item].value;
      });
    }
  }, {
    key: "setValueToSelected",
    value: function setValueToSelected(value) {
      var _this13 = this;

      var notReset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.multiple && value.length > 1) {
        throw new Error('cascader is not multiple but has more than one value');
      }

      if (!notReset) {
        this.resetHashState();
      }

      if (!value.length) {
        this.value = [];
        return;
      }

      var unvalid = false;
      value.forEach(function (item) {
        var id = _this13.getIdByValue(item);

        if (!_this13.hashMap[id]) {
          unvalid = true;
          return;
        }

        if (_this13.spread && _this13.hashMap[id].children && _this13.hashMap[id].children.length) {
          unvalid = true;
          return;
        }

        _this13.updateSelectedState(id, CascaderState.SELECTED);
      });

      if (unvalid) {
        value = this.getValueFromSelected();
      }

      this.value = value;
    }
  }, {
    key: "getIdByValue",
    value: function getIdByValue(value) {
      return this.valueHash[String(value)];
    }
  }, {
    key: "getIdsByValues",
    value: function getIdsByValues(values) {
      var _this14 = this;

      var ids = [];
      values.forEach(function (item) {
        ids.push(_this14.getIdByValue(item));
      });
      return ids;
    }
  }, {
    key: "setPos",
    value: function setPos() {
      var _this15 = this;

      var cache = new Map();
      Object.entries(this.hashMap).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            id = _ref2[0],
            element = _ref2[1];

        cache.set(element.value, id);
      });

      var _loop = function _loop(data, path) {
        (data === null || data === void 0 ? void 0 : data.length) && data.forEach(function (element, index) {
          var mapId = cache.get(element.value);
          _this15.getItemInfo(mapId).position = path + '-' + index;

          _loop(element.children, path + '-' + index);
        });
      };

      _loop(this.datasource, '0');
    }
  }]);

  return CascaderCore;
}(Emitter);